import styled from 'styled-components';

const LabelText = styled.p`
  align-items: center;
  color: ${Styles.color.grey.two};
  font-size: 0.9375rem;
  display: flex;
  flex-wrap: wrap;
  flex-grow: 1;
  flex-shrink: 1;
  font-family: ${Styles.fontFamily.body};
  margin: 0 0 0 10px;
`;

export default LabelText;
